/* eslint-disable */
import styled from 'styled-components'
import { CancelButton, ModalButton } from '../styles'

const AssignAdminBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const CreateQuestion = styled(ModalButton)`
  margin-left: auto;
`


export { ModalButton, CancelButton, CreateQuestion, AssignAdminBlock }
